import $ from "jquery";

export default class AnimateDigits {
  init() {
    $('.animated-number').each(function () {
      var $el_digit = $(this);

      $el_digit.data("count_to", $el_digit.text());

      if ($el_digit.data("counting-animation-start")) {
        $el_digit.text($el_digit.data("counting-animation-start"));
      } else {
        $el_digit.text("0");
      }
    });

    $(window).scroll(function () {
      $('.animated-number').each(function () {
        //var $cur_value = parseInt($(this).text());

        if (isScrolledIntoView($(this))) {

          //if ($cur_value == 0) {
            startDigitAnimation($(this));
          //}
        }
      });
    });

    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    function startDigitAnimation(elem) {
      var from_d = parseInt($(elem).text(), 10);
      var to_d = parseInt($(elem).data("count_to"), 10);

      var props = {
        "from": {
          "count": from_d
        },
        "to": {
          "count": to_d
        }
      };

      $(props.from).animate(props.to, {
        duration: 3000 * 1,
        step: function (now) {
          $(elem).text(Math.ceil(now));
        },
        complete: function () {

        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/animate-digits.js